// components/CompactSpaceCard.js
import React from 'react';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

const CompactSpaceCard = ({ space, isActive, onClick }) => {


    const {t} = useTranslation("global");
    const capacityText = t("spaceCard.capacityLabel", { capacity: space.max_capacity });
  return (
    <div
      className={`${styles.compactSpaceCard} ${isActive ? styles.active : ''}`}
      onClick={onClick}
    >
      <div 
        className={styles.spaceImage}
        style={{ backgroundImage: `url(${space.images[0]?.image_url})` }}
      />
      <div className={styles.spaceInfo}>
        <h4 className={styles.spaceName}>{space.name}</h4>
        <div className={styles.spaceMeta}>
          <span className={styles.capacity}>{capacityText} </span>
          {space.last_minute && (
            <span className={styles.lastMinuteBadge}>Last Minute</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompactSpaceCard;